module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/052-kosovo-83b700cb3e8b40d44b6ca40ec65e18db.svg";